import * as React from 'react';
import sanitizeHtml from 'sanitize-html';

import { ModalFrame, ModalFrameEntity, ModalFrameFooter, ModalFrameHeader, ModalFrameMessage } from 'components/modal';
import ActionButton from 'components/buttons/action-button/ActionButton';
import ModalFrameInner from 'components/modal/modal-frame-inner/ModalFrameInner';

import { __t, applyTranslations } from 'utils/language';

import './offer-congrats-modal.scss';

import type { Subcampaign } from 'types';

applyTranslations(require('./offer-congrats-modal.i18n.json'));

type Props = {
  subcampaign: Subcampaign,
  onClose: () => void
};

class OfferCongratsModal extends React.PureComponent<Props> {
  getMessengerTextWithLink() {
    const { subcampaign } = this.props;

    // odd structure below is so the period (.) doesn't have space between the link and itself
    const link = {
      messenger: `
        <a
          href="/campaigns/${subcampaign.campaign.id}/messages?subcampaignId=${subcampaign.id}"
          class="offer-congrats-modal__link"
          target="_blank"
        >
          ${__t('offer_congrats_modal.messenger')}</a>.
      `
    };

    return sanitizeHtml(__t('offer_congrats_modal.messenger_note', link), {
      allowedTags: ['a'],
      allowedAttributes: {
        a: ['href', 'class', 'target']
      }
    });
  }

  renderFooter(): React.ReactNode {
    const { subcampaign, onClose } = this.props;

    return (
      <ModalFrameFooter>
        <ActionButton
          color="tertiary"
          onClick={onClose}
          data={{ qa: 'offer-congrats-modal__button-view-offer' }}
        >
          {__t('offer_congrats_modal.button_view_offer')}
        </ActionButton>
        <ActionButton
          link={`/campaigns/${subcampaign.campaign.id}/participants/shortlisted`}
          data={{ qa: 'offer-congrats-modal__button-go-to-shortlist' }}
        >
          {__t('offer_congrats_modal.button_shortlist')}
        </ActionButton>
      </ModalFrameFooter>
    );
  }

  render(): React.ReactNode {
    const { subcampaign } = this.props;

    return (
      <ModalFrame data-qa="offer-congrats-modal">
        <ModalFrameHeader
          title={__t('offer_congrats_modal.title')}
        />
        <ModalFrameEntity
          influencerProfile={subcampaign.creatorProfile}
        />
        <ModalFrameMessage
          message={__t('offer_congrats_modal.body')}
        />
        <ModalFrameMessage
          message={`<em>${subcampaign.campaign.name}</em>`}
        />
        {this.renderFooter()}
        <ModalFrameInner align="center">
          <div dangerouslySetInnerHTML={{ __html: this.getMessengerTextWithLink() }} />
        </ModalFrameInner>
      </ModalFrame>
    );
  }
}

export default OfferCongratsModal;
